<nav [ngClass]="{'menu-collapsed': !isMenuExpanded, 'route-triggered': routeTriggered, 'keyboard-triggered': keyboardTriggered, 'in-focus': isInFocus}" (mouseleave)="menuMouseLeave()">
  <header>
    <a class="toggle-menu-collapse" (click)="toggleMenuCollapse()" tabindex="-1">
      <i class="icon icon-sidebar_toggle"></i>
    </a>
  </header>
  <div class="menu-items" role="tree" name="menu" accesskey="w" tabindex="{{tabIndex}}" [attr.aria-activedescendant]="ariaActiveDescendant" (focus)="onFocus()" (focusout)="onFocusOut()">
    <ul *ngIf="inputMenuItems">
    <li [id]="menuItem.id" *ngFor="let menuItem of inputMenuItems" tabindex="-1" [ngClass]="{'menu-item-selected': (menuItem == focusedItem && focusedSubItem==null)}" [attr.aria-selected]="(menuItem == focusedItem && focusedSubItem==null)" [attr.aria-expanded]="!menuItem.subItems ? null : menuItem.expanded ? true : false" role="treeitem" aria-level="1">
      <a title="{{menuItem.key | translate}}"
        class="menu-item"
        (click)="handleMenuEvent(menuItem, $event)"
        [ngClass]="{'active-item': menuItem == activeItem}">
        <i class="menu-item-icon" *ngIf="menuItem.icon" [ngClass]="menuItem.icon"></i>
        <span class="menu-item-title">{{menuItem.key | translate}}</span>
        <svg *ngIf="menuItem.subItems" class="menu-item-expand" [ngClass]="{'expanded': menuItem.expanded}" viewBox="0 0 20 20" focusable="false">
            <path d="M8.79,15,.3,6.49A1,1,0,0,1,1.76,5l8,8,8.5-8A1,1,0,1,1,19.7,6.49l-9,8.49a1.68,1.68,0,0,1-.94.26A1.65,1.65,0,0,1,8.79,15Z" />
        </svg>
      </a>
      <ul class="sub-menu" *ngIf="menuItem.subItems" [ngClass]="{'expanded': menuItem.expanded}" role="group">
        <li [id]="subItem.id" *ngFor="let subItem of menuItem.subItems" tabindex="-1" [ngClass]="{'menu-item-selected': (subItem == focusedSubItem)}" [attr.aria-selected]="(subItem == focusedSubItem)" role="treeitem" aria-level="1">
          <a title="{{subItem.key | translate}}" class="sub-menu-item"
            (click)="handleSubMenuEvent(menuItem, subItem, $event)"
            [ngClass]="{'active-sub-item': subItem == activeSubItem}">
            <span>{{subItem.key | translate}}</span>
          </a>
        </li>
      </ul>
    </li>
    </ul>
  </div>
</nav>
